import React, { useState, useEffect } from 'react';

// Import components

// Import CSS & assets
import './Search.css';
import close from '../../../assets/ico/ico_close.svg';
import * as filter_list from './FiltersList';
import FilterCatalogItem from './FilterCatalogItem';
import * as search_helpers from '../../../components/app/search_elements/Search_helpers.js';


// Get lists
const filters_list = filter_list.get_filters_list();



const FiltersCatalog = ({ capacity, setCapacity, setIsFilterCatalogOpen, searchParameters, setSearchParameters }) => {

    // Close
    const closeRuleCatalog = () => {
        setIsFilterCatalogOpen(false);
    }

    // _____ FILTER CATALOG
    const [filterString, setFilterString] = useState("");
    const [filteredFiltersCatalog, setFilteredFiltersCatalog] = useState({ ...filters_list });
    const handleFilterChange = (newFilter) => {
        // Update filterString
        setFilterString(newFilter);
        // Filter list
        if (newFilter === "") {
            setFilteredFiltersCatalog({ ...filters_list });
        }

    }
    // On load : Reset filter
    useEffect(() => {
        setFilterString("");
    }, []);


    // Add filter
    const handleFilterAdd_Click = (filter_id) => {
        if (capacity?.search?.currentFiltersIds && capacity.search.currentFiltersIds.includes(filter_id)) {
        }
        else {
            // Get filter_data
            var filter_data = filter_list.get_filter_from_id(filter_id);
            console.log("FILTER DATA", filter_data);
            if (filter_data) {
                // Create new element model
                var filter_new = { id: filter_id, label: filter_data.label, description: filter_data.description, position: filter_data.position, values: { ...filter_data?.default_values } };
                // Get current search
                var search = capacity?.search || { currentFiltersIds: [], currentFilters: {} };
                // Add filter
                search.currentFiltersIds.push(filter_id);
                search.currentFilters[filter_id] = filter_new;
                // toSave params
                var toSaveData = { ...capacity.toSave };
                if (!toSaveData?.keys) { toSaveData.keys = [] }
                toSaveData.keys.push("rules__search");
                toSaveData.autoSave = false;
                toSaveData.action = "";
                toSaveData.value = "";
                // Update capacity
                setCapacity({ ...capacity, search: search, toSave: toSaveData });
                // Start filter loading
                search_helpers.search_create_filter(filter_id, searchParameters, setSearchParameters);
            }
        }
        closeRuleCatalog();
    }



    return (
        <div className="app__rulecatalog_back">
            <div className="app__rulecatalog_container scale-up-center">
                {/* <div className="app__rulecatalog_container"> */}
                <div className="app__rulecatalog_close_container" onClick={closeRuleCatalog}><img src={close} alt="close" /></div>
                <div className="app__rulecatalog_header_container">
                    <div className="app__rulecatalog_header_subcontainer">
                        <div className={`app__rulecatalog_header_label app__rulecatalog_header_label_focus`}>Catalogue de critères</div>
                    </div>
                </div>
                <div className="app__rulecatalog_body_container">
                    {/* SECTION CATALOG */}
                    <div className={`app__rulecatalog_section`}>
                        {/* RULES FILTER */}
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <div className="app__rulecatalog_filter_container">
                                <div className="common__input_container">
                                    {/* <input className="app__rulecatalog_filter" style={{ color: 'lightgrey' }} type="text" id="rulecatalog_filter" name="filter" placeholder="Rechercher une règle" onChange={(e) => { }}></input> */}
                                    <input type="text" className="app__rulecatalog_filter" placeholder="Rechercher" name="ruleCatalogFilter" id="ruleCatalogFilter" value={filterString} onChange={(e) => { handleFilterChange(e.target.value) }} autoComplete="off"></input>
                                    <label htmlFor="ruleCatalogFilter" className="app__rulecatalog_filter_label">Rechercher un critère</label>
                                    <img className={filterString !== "" ? "app__rulecatalog_filter_ico" : "app__rulecatalog_filter_ico app__rulecatalog_filter_ico_hidden"} src={close} alt='reset' onClick={() => { handleFilterChange("") }} />
                                </div>
                            </div>
                        </div>
                        <div className="app__sectiondata_widget_spacer_30"></div>
                        <div className="app__rulecatalog_subsection">
                            {/* RULES OF CATALOG BY CATEGORY */}
                            {Object.keys(filteredFiltersCatalog).map((category, index) => {
                                if (category !== "popular") {
                                    return (
                                        <section key={"section_" + index}>
                                            <div className="app__rulecatalog_title_container">
                                                <div className="app__rulecatalog_title">{filteredFiltersCatalog[category]?.label}</div>
                                            </div>
                                            <div className="app__rulecatalog_rule_grid">
                                                {filteredFiltersCatalog[category].items.map((filter, filter_index) => {
                                                    return (
                                                        <FilterCatalogItem key={"section_" + index + "_" + filter_index} filter_data={filter} handleFilterAdd_Click={handleFilterAdd_Click} searchParameters={searchParameters} />
                                                    )
                                                })}
                                            </div>
                                        </section>
                                    )
                                }
                            })}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default FiltersCatalog;